import React from "react";

export default function MiniBox({data, containerStyle, boxStyle, headingStyle, textStyle}) {
  return (
    <div className={`flex flex-wrap justify-center p-[2%_0%_1%_0%] mx-auto ${containerStyle}`}>
      {data.map(({ title, text }, index) => {
        return (
          <div
            key={title + index}
            className={`bg-white rounded-[10px] text-center ${boxStyle}`}
          >
            <h3 className={`font-bold my-[0.67em] text-[16px] leading-[26px] ${headingStyle}`}>
              {title}
            </h3>

            <p className={`text-[12px] md:text-[14px] mb-5 font-open ${textStyle}`}>{text}</p>
          </div>
        );
      })}
    </div>
  );
}
